import { computed } from "vue";
import { useRoute } from "vue-router";
import { tradeFabDetailContext } from "@/utils/tradeFabDetailContext";
import { tradeFabListContext } from "@/utils/tradeFabListContext";
import { tradeFabMyAssetsContext } from "@/utils/tradeFabMyAssetsContext";
function pickQuery(v) {
    if (v == null)
        return "";
    if (Array.isArray(v))
        return v[0] != null ? String(v[0]) : "";
    return String(v);
}
function stripPrice(s) {
    return String(s ?? "").replace(/[^\d.]/g, "");
}
export function useTradeFabRouteContext() {
    const route = useRoute();
    const isOnSaleListPath = computed(() => /^\/on-sale\/[^/?#]+/.test(route.path));
    const myAssetsWarehouseGId = computed(() => {
        if (route.path !== "/my-assets")
            return "";
        const g = String(tradeFabMyAssetsContext.gId || "").trim();
        const n = Number(g);
        if (!Number.isFinite(n) || n <= 0)
            return "";
        return String(Math.floor(n));
    });
    const uniqueGId = computed(() => {
        if (myAssetsWarehouseGId.value)
            return myAssetsWarehouseGId.value;
        if (isOnSaleListPath.value)
            return "";
        const pm = route.path.match(/^\/product\/([^/?#]+)/);
        if (!pm)
            return "";
        if (tradeFabDetailContext.fullPath === route.fullPath && tradeFabDetailContext.uniqueGId) {
            return tradeFabDetailContext.uniqueGId;
        }
        const gid = pickQuery(route.query.gId);
        const n = Number(String(gid).trim());
        if (!Number.isFinite(n) || n <= 0)
            return "";
        return String(Math.floor(n));
    });
    const albumId = computed(() => {
        if (route.path === "/my-assets" && myAssetsWarehouseGId.value) {
            const aid = String(tradeFabMyAssetsContext.albumId || "").trim();
            if (aid)
                return aid;
        }
        const osl = route.path.match(/^\/on-sale\/([^/?#]+)/);
        if (osl)
            return decodeURIComponent(osl[1]);
        const pm = route.path.match(/^\/product\/([^/?#]+)/);
        return pm ? decodeURIComponent(pm[1]) : "";
    });
    const gNum = computed(() => {
        if (!uniqueGId.value)
            return "";
        if (route.path === "/my-assets" && myAssetsWarehouseGId.value) {
            return String(tradeFabMyAssetsContext.gNum || "").trim();
        }
        if (tradeFabDetailContext.fullPath === route.fullPath && tradeFabDetailContext.gNum) {
            return tradeFabDetailContext.gNum;
        }
        const q = pickQuery(route.query.gNum);
        const n = Number(String(q).trim());
        if (!Number.isFinite(n) || n <= 0)
            return "";
        return String(Math.floor(n));
    });
    const albumName = computed(() => {
        if (route.path === "/my-assets" && myAssetsWarehouseGId.value) {
            return String(tradeFabMyAssetsContext.albumName || "").trim();
        }
        if (isOnSaleListPath.value) {
            if (tradeFabListContext.fullPath === route.fullPath) {
                return tradeFabListContext.albumName;
            }
            return "";
        }
        if (uniqueGId.value) {
            if (tradeFabDetailContext.fullPath === route.fullPath && tradeFabDetailContext.albumName) {
                return tradeFabDetailContext.albumName;
            }
            return pickQuery(route.query.albumName);
        }
        return "";
    });
    const price = computed(() => {
        if (route.path === "/my-assets" && myAssetsWarehouseGId.value) {
            return stripPrice(tradeFabMyAssetsContext.price);
        }
        if (isOnSaleListPath.value) {
            if (tradeFabListContext.fullPath === route.fullPath && tradeFabListContext.suggestedPrice) {
                return stripPrice(tradeFabListContext.suggestedPrice);
            }
            return "";
        }
        if (uniqueGId.value) {
            if (tradeFabDetailContext.fullPath === route.fullPath && tradeFabDetailContext.price) {
                return stripPrice(tradeFabDetailContext.price);
            }
            return stripPrice(pickQuery(route.query.price));
        }
        return "";
    });
    const issueNum = computed(() => {
        if (!isOnSaleListPath.value)
            return "";
        if (tradeFabListContext.fullPath === route.fullPath) {
            return tradeFabListContext.issueNum;
        }
        return "";
    });
    const soldNum = computed(() => {
        if (!isOnSaleListPath.value)
            return "";
        if (tradeFabListContext.fullPath === route.fullPath) {
            return tradeFabListContext.soldNum;
        }
        return "";
    });
    return {
        uniqueGId,
        albumId,
        albumName,
        gNum,
        price,
        issueNum,
        soldNum
    };
}
